import { createReducer } from 'redux-act';
import actions from '../actions/ApprovalManagementActions';

const initialState = {
  addHierarchyPending: false,
  addHierarchyRes: null,
  addHierarchyError: null,

  getAllHierarchyPending: false,
  getAllHierarchyRes: null,
  getAllHierarchyError: null,

  updateHierarchyPending: false,
  updateHierarchyRes: null,
  updateHierarchyError: null,

  deleteHierarchyPending: false,
  deleteHierarchyRes: null,
  deleteHierarchyError: null,
};
/* Add Hierarchy Reducers */
const handleAddHierarchyRequest = state => {
  return {
    ...state,
    ...{
      addHierarchyPending: true,
      addHierarchyRes: null,
      addHierarchyError: null,
    },
  };
};
const handleAddHierarchySuccess = (state, payload) => {
  return {
    ...state,
    ...{
      addHierarchyPending: false,
      addHierarchyRes: payload,
      addHierarchyError: null,
    },
  };
};
const handleAddHierarchyError = (state, payload) => ({
  ...state,
  ...{
    addHierarchyPending: false,
    addHierarchyRes: null,
    addHierarchyError: payload,
  },
});


/* Get All Hierarchy Reducers */
const handleGetAllHierarchyRequest = state1 => {
  return {
    ...state1,
    ...{
      getAllHierarchyPending: true,
      getAllHierarchyRes: null,
      getAllHierarchyError: null,
    },
  };
};
const handleGetAllHierarchySuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      getAllHierarchyPending: false,
      getAllHierarchyRes: payload,
      getAllHierarchyError: null,
    },
  };
};
const handleGetAllHierarchyError = (state1, payload) => ({
  ...state1,
  ...{
    getAllHierarchyPending: false,
    getAllHierarchyRes: null,
    getAllHierarchyError: payload,
  },
});

/* Update Hierarchy Reducers */
const handleUpdateHierarchyRequest = state1 => {
  return {
    ...state1,
    ...{
      updateHierarchyPending: true,
      updateHierarchyRes: null,
      updateHierarchyError: null,
    },
  };
};
const handleUpdateHierarchySuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      updateHierarchyPending: false,
      updateHierarchyRes: payload,
      updateHierarchyError: null,
    },
  };
};
const handleUpdateHierarchyError = (state1, payload) => ({
  ...state1,
  ...{
    updateHierarchyPending: false,
    updateHierarchyRes: null,
    updateHierarchyError: payload,
  },
});

/* Delete Hierarchy Reducers*/ 
const handleDeleteHierarchyRequest = state1 => {
  return {
    ...state1,
    ...{
      deleteHierarchyPending: true,
      deleteHierarchyRes: null,
      deleteHierarchyError: null,
    },
  };
};
const handleDeleteHierarchySuccess = (state1, payload) => {
  return {
    ...state1,
    ...{
      deleteHierarchyPending: false,
      deleteHierarchyRes: payload,
      deleteHierarchyError: null,
    },
  };
};
const handleDeleteHierarchyError = (state1, payload) => ({
  ...state1,
  ...{
    deleteHierarchyPending: false,
    deleteHierarchyRes: null,
    deleteHierarchyError: payload,
  },
});

// Clear Existing Data Store Reducers*/
const clearHierarchyStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR_ADD_HIERARCHY_STORE':
      return {
        ...state,
        ...{
          addHierarchyPending: false,
          addHierarchyRes: null,
          addHierarchyError: null,
        },
      };
    case 'HANDLE_CLEAR_UPDATE_HIERARCHY_STORE':
      return {
        ...state,
        ...{
          updateHierarchyPending: false,
          updateHierarchyRes: null,
          updateHierarchyError: null,
        },
      };
    case 'HANDLE_CLEAR_DELETE_HIERARCHY_STORE':
      return {
        ...state,
        ...{
          deleteHierarchyPending: false,
          deleteHierarchyRes: null,
          deleteHierarchyError: null,
        },
      };
    default:
      return state;
  }
};



export default createReducer(
  {
    [actions.addHierarchyRequest]: handleAddHierarchyRequest,
    [actions.addHierarchySuccess]: handleAddHierarchySuccess,
    [actions.addHierarchyError]: handleAddHierarchyError,

    [actions.getAllHierarchyRequest]: handleGetAllHierarchyRequest,
    [actions.getAllHierarchySuccess]: handleGetAllHierarchySuccess,
    [actions.getAllHierarchyError]: handleGetAllHierarchyError,

    [actions.updateHierarchyRequest]: handleUpdateHierarchyRequest,
    [actions.updateHierarchySuccess]: handleUpdateHierarchySuccess,
    [actions.updateHierarchyError]: handleUpdateHierarchyError,

    [actions.deleteHierarchyRequest]: handleDeleteHierarchyRequest,
    [actions.deleteHierarchySuccess]: handleDeleteHierarchySuccess,
    [actions.deleteHierarchyError]: handleDeleteHierarchyError,

    [actions.handleClearHierarchyStore]: clearHierarchyStore,
  },
  initialState,
);